module.exports = __webpack_public_path__ + "img/img7.913a85c0.png";